import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: 32,
    },
    header: {
      ...theme.fonts.h4,
      paddingLeft: 8,
      position: "relative",
      top: 4,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
